<template>
  <div class="themPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>专题名称：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px"
                    v-model="specialName"></el-input>
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'2','value':'审核中'},{'key':'1','value':'审核通过'},{'key':'3','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column label="封面图" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 160px; height: 80px"
                    :src="scope.row.img_url"
                    :preview-src-list="scope.row.img_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="专题名称" prop="special_name" align="center"></el-table-column>
          <el-table-column width="120" label="专题类型" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.special_type === 1 ? '新闻':'视频' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="专题说明" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.special_explain }}
                </template>
                <span
                    style="width:260px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{
                    scope.row.special_explain
                  }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag v-if="scope.row.examine_status === '1'" type="success" size="small" effect="dark">审核通过</el-tag>
                <el-tag v-if="scope.row.examine_status === '2'" type="danger" size="small" effect="dark">审核中</el-tag>
                <el-tag v-if="scope.row.examine_status === '3'" type="info" size="small" effect="dark">审核未通过</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="权重时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.sortTime }}
                </template>
                {{ scope.row.sortTimeList[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.create_date }}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>

          <el-table-column
              align="center"
              label="操作"
              width="300"
          >
            <template slot-scope="scope">
              <el-button size="small" @click="navTo(scope.row)" type="primary">专题标签</el-button>
              <el-button size="small" @click="editBtn(scope.row)" type="success">修改</el-button>
              <el-button size="small" @click="deleteBtn(scope.row)" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="600px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="封面图片" prop="imgUrl">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="avatar-uploader">
            <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>
        <el-form-item label="专题名称" prop="specialName">
          <el-input v-model="ruleForm.specialName" style="width: 400px" size="small" placeholder="请输入专题名称"></el-input>
        </el-form-item>
        <el-form-item label="专题类型" prop="specialType">
          <el-select :disabled="dialogTitle === '专题修改'" v-model="ruleForm.specialType" size="small" style="width: 400px;margin-right: 10px" clearable
                     placeholder="请选择专题类型">
            <el-option
                v-for="item in [{'key':1,'value':'新闻'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="专题类型" prop="specialType">
          <el-select :disabled="dialogTitle === '专题修改'" v-model="ruleForm.specialType" size="small" style="width: 400px;margin-right: 10px" clearable
                     placeholder="请选择专题类型">
            <el-option
                v-for="item in [{'key':1,'value':'新闻'},{'key':2,'value':'视频'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="专题说明" prop="specialExplain">
          <el-input v-model="ruleForm.specialExplain" type="textarea" :rows="3" style="width: 400px" size="small"
                    placeholder="请输入专题说明"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

  </div>
</template>

<script>
import moment from "moment";
import {baseURL} from "@/api/config";

export default {
  data() {
    return {
      specialName: null,
      examineStatus: null,
      pageNum: 1,
      pageSize: 20,
      tableData: [],
      totalElements: 0,
      deleteDialogState: false,
      deleteId: '',
      simpleDelete: false,//是单个删除还是多个删除
      addDialogState: false,
      dialogTitle: '',
      ruleForm: {
        id: null,
        specialName: '',
        specialType: null,
        specialExplain: '',
        imgUrl: ''
      },
      rules: {
        imgUrl: [{required: true, message: "请选择封面图", trigger: "blur"}],
        specialName: [{required: true, message: "请输入专题名称", trigger: "blur"}],
        specialType: [{required: true, message: "请选择专题类型", trigger: "blur"}],
        specialExplain: [{required: true, message: "请输入专题说明", trigger: "blur"}],
      },
      uploadDisabled: false,
      uploadApiUrl: '',
      coverUrlList: [],
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadUserHeadImg'
    this.getList()
  },
  methods: {
    searchBtn() {
      this.getList();
    },
    addBtn() {
      this.ruleForm = {
        id: null,
        specialName: '',
        specialType:1,
        specialExplain: '',
        imgUrl: ''
      }
      this.dialogTitle = '专题新增'
      this.addDialogState = true
    },
    resetBtn() {
      this.specialName = null
      this.examineStatus = null
      this.getList();
    },
    editBtn(row) {
      this.ruleForm.id = row.id
      this.ruleForm.imgUrl = row.img_url
      this.ruleForm.specialName = row.special_name
      this.ruleForm.specialType = row.special_type
      this.ruleForm.specialExplain = row.special_explain
      this.dialogTitle = '专题修改'
      this.addDialogState = true
    },
    navTo(row) {
      this.$router.push({
        path: "/thematicTagList", query: {
          id: row.id,
          specialName: row.special_name,
          type: row.special_type
        }
      });
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '专题新增') {
            this.postAxios("/special/create", {
              imgUrl: this.ruleForm.imgUrl,
              authorId:localStorage.getItem("loginId"),
              specialName: this.ruleForm.specialName,
              specialType: this.ruleForm.specialType,
              specialExplain: this.ruleForm.specialExplain,
            }).then(res => {
              this.$message.success("添加成功!")
              this.addDialogState = false
              this.getList()
            })
          } else {
            this.postAxios("/special/update", {
              id: this.ruleForm.id,
              authorId:localStorage.getItem("loginId"),
              imgUrl: this.ruleForm.imgUrl,
              specialName: this.ruleForm.specialName,
              specialType: this.ruleForm.specialType,
              specialExplain: this.ruleForm.specialExplain,
            }).then(res => {
              this.$message.success("修改成功!")
              this.addDialogState = false
              this.getList()
            })
          }
        }
      });
    },
    getList() {
      this.postAxios("/special/getAllSpecial", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          loginId:localStorage.getItem("loginId"),
          specialName: this.specialName ? this.specialName : null,
          examineStatus: this.examineStatus ? this.examineStatus : null,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content
          this.tableData.forEach((item) => {
            item.img_urlList = []
            if (item.img_url) {
              item.img_urlList.push(item.img_url)
            }
            if (item.create_date) {
              item.create_date_list = item.create_date.split(' ')
            }
            if (item.sort || item.sort === 0) {
              item.sortTime = moment(item.sort).format('YYYY-MM-DD HH:mm:ss')
              item.sortTimeList = item.sortTime.split(' ')
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.postAxios("/special/delete?id=" + this.deleteId, {
          id: this.deleteId
        }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.success) {
        this.ruleForm.imgUrl = res.entity;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt8M = file.size / 1024 / 1024 < 8;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt8M) {
        this.$message.error('上传头像图片大小不能超过 8MB!');
      }
      return isJPG && isLt8M;
    }
  }
}
</script>

<style scoped>

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
  height: 100px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 200px;
  height: 100px;
  display: block;
}
</style>
